var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
if (!customElements.get('sticky-atc')) {
  class stickyAtc extends HTMLElement {
    constructor() {
      super();

      this.mainHeader = document.querySelector('#shopify-section-header');
      this.mainATCWrapper = document.querySelector('.product--button-wrapper');
      this.mainATC = this.mainATCWrapper.querySelector('.ProductForm__AddToCart');
      this.mainRadios = document.querySelectorAll('.ProductForm__Variants input[type="radio"]');
      this.variantJson = JSON.parse(this.querySelector('[data-variant-json]').textContent);
      this.atcBtn = this.querySelector('[data-atc]');
      this.variantRadios = this.querySelectorAll('.variants-wrapper input[type="radio"]');

      this.init();
    }

    onChange = () => {
      document.addEventListener('variant:changed', (e) => {
        let option1 = e.detail.variant.option1,
            option2 = e.detail.variant.option2,
            option3 = e.detail.variant.option3;
        let money = Shopify.formatMoney(e.detail.variant.price,theme.moneyFormat);
        this.variantRadios.forEach(radio => {
          if (radio.value == option1 || radio.value == option2 || radio.value == option3) {
            radio.checked = true;
          }
        });
        if (e.detail.variant.available) {
          this.atcBtn.innerHTML = `${window.languages.productFormAddToCart} <span>•</span> ${money}`;
          this.atcBtn.disabled = false;
        } else {
          this.atcBtn.innerHTML = `${window.languages.productFormSoldOut} <span>•</span> ${money}`;
          this.atcBtn.disabled = true;
        }
      });

      this.variantRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          let currOpts = [];
          this.variantRadios.forEach(radio => {
            if (radio.checked) {
              currOpts.push(radio.value);
            }
          });

          this.mainRadios.forEach(radio => {
            if (currOpts.indexOf(radio.value) >= 0) {
              radio.click()
            }
          });
        });
      });
    }

    toggleStickyBar = () => {
      let events = ['resize','scroll','DOMContentLoaded'];
      events.forEach(e  => {
        window.addEventListener(e, () => {
          if(screen.width < 990) {

          
        }
        else{
          if(window.pageYOffset >52){
           
          }
          else{
           
          }

        }
        

          if (window.innerWidth < 1008) {
            this.style.display = 'none'
          } else {
            this.style.display = null
          }
          this.style.setProperty('--top',`${this.mainHeader.clientHeight}px`);
          let atcOffset = (this.mainHeader.clientHeight + 50) - this.mainATCWrapper.getBoundingClientRect().bottom;
          if (window.pageYOffset > 1000) {
            this.classList.add('active');
          } else {
            this.classList.remove('active');
          }
          if (window.pageYOffset > 1000) {
            document.querySelector(".sticky-atc-index").style="position:relative"
            
            document.querySelector(".sticky-atc-index").style="opacity:1"
          } 
          else {
            document.querySelector(".sticky-atc-index").style="position:absolute"
            document.querySelector(".sticky-atc-index").style="opacity:0"
          }
        })
      })
    }
    handleATC = () => {
      this.atcBtn.addEventListener('click', () => {
        this.mainATC.click();
      })
    }

    init = () => {
      this.onChange();
      this.toggleStickyBar();
      this.handleATC();
    }
  }
  customElements.define('sticky-atc', stickyAtc);
}